import { createSlice } from "@reduxjs/toolkit";

export const Ui = createSlice({
  name: "alert",
  initialState: {
    redirectToPricing: false,
    firstTimeRegistration: false,
  },
  reducers: {
    setRedirectToPricingPage: (state, action) => {
      state.redirectToPricing = action.payload;
    },
    setFirstTimeRegistration: (state, action) => {
      state.firstTimeRegistration = action.payload;
    },
  },
});

export const { setRedirectToPricingPage, setFirstTimeRegistration } =
  Ui.actions;

export default Ui.reducer;
